
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ components: {} })
export default class ToastKnockedUser extends Vue {
  @Prop() private message!: string;

  private clicked(sendMessage: string): void {
    this.$emit('clickButtonOnToast', sendMessage);
    this.$emit('close-toast', sendMessage);
  }
}
